<ng-container class="agpr-mentionDetails" *ngIf="mention">
    @if (!hasAdvancedMonitoringPermissions) {
        <div class="agpr-mentionDetails-upsell">
            <span
                class="agpr-mentionDetails-upsellIcon fa-regular fa-duotone fa-lock"
                aria-hidden="true"
            ></span>
            <div>{{'Mention.details.advancedMonitoringUpsell' | localize}}</div>
            <agpr-button
                [id]="'mentionDetails_upsell_unlockButton'"
                [label]="'Discover.entityProfile.recentCoverage.subscribeNow'"
                [style]="buttonTypes.primary"
                (click)="unlockMentionView()"
            ></agpr-button>
        </div>
    } @else {
        <agpr-panel
            [showHeader]="!isDetailsTakeOverPanel"
            header="Mention.details.mentionInformation"
            [marginTop]='mentionAttributes?.length > 0 ? 10 : 0'
        >
            <div class="agpr-mentionDetails-mentionInformation-metadataWrapper">
                @for (attribute of mentionInformation; track attribute.id) {
                    @if (attribute.id === mentionAttributeTypesEnum.audienceReach
                        || attribute.id === mentionAttributeTypesEnum.adValueUsd
                        || attribute.id === mentionAttributeTypesEnum.location
                        || (attribute?.value !== null && attribute?.value !== undefined)
                    ) {
                        <agpr-meta-data
                            [id]="id"
                            class="agpr-mentionDetails-mentionInformation-metadata"
                            [type]="attribute.type"
                            [mediaType]="attribute.mediaType"
                            [icon]="attribute.icon"
                            [value]="attribute.value"
                            [isSimilarWeb]="attribute.isSimilarWeb"
                            [tooltip]="attribute.label"
                            [infoTooltip]="attribute.infoTooltip"
                            [isMultiline]="attribute.id === mentionAttributeTypesEnum.location"
                        ></agpr-meta-data>
                    }
                }
            </div>
            @if (mention.note) {
                <div class="agpr-mentionDetails-notesHeading">
                    {{ ('Mention.details.notes' | localize) }}
                </div>
                <section class="agpr-mentionDetails-notesBody">
                    <p
                        class="agpr-mentionDetails-paragraph"
                        *ngFor="let paragraph of notesParagraphs"
                        [innerHTML]="
                            paragraph
                                | mentionLinks : mention.mediaType.id
                                | highlightKeywords:highlightKeywords
                        "
                    ></p>
                </section>
            }
        </agpr-panel>

        @if (mentionAttributes?.length > 0) {
            <agpr-panel header="Mention.mentionOrganization">
                <ng-template #panelHeader>
                    <agpr-button
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-gear"
                        agprTooltip="Mention.manageMentionOrganization.gearIcon.tooltip"
                        tooltipPosition="top"
                        (click)="openManageMentionOrganizationDialog()"
                    ></agpr-button>
                </ng-template>
                <agpr-tags-picker
                    [(ngModel)]="mention.tagIds"
                    (ngModelChange)="tagsUpdated($event)"
                ></agpr-tags-picker>
                <agpr-folders-picker
                    [folders]="folders"
                    (addFolder)="addMentionToFolder($event)"
                    (removeFolder)="removeMentionFromFolder($event)"
                ></agpr-folders-picker>
            </agpr-panel>
        }

        @if (mention.mediaType.isSocial) {
            <agpr-panel header="Mention.details.engagement">
                <ng-template #panelHeader>
                    @if (mention?.lastModifiedDate) {
                        <span
                            role="img"
                            class="fa-regular fa-circle-info agpr-infoIconStyle"
                            [agprTooltip]="'Mention.details.engagement.tooltip' | localize: { dateTime: (mention.lastModifiedDate | changeTimeZone: preferences.timeZone: dateFormat) }"
                            [escape]="false"
                            tooltipPosition="right"
                        ></span>
                    } @else {
                        <span
                            role="img"
                            class="fa-regular fa-circle-info agpr-infoIconStyle"
                            [agprTooltip]="mention?.engagementLastFetchedDate ?
                                ('Mention.details.engagement.tooltip' | localize: { dateTime: (mention.engagementLastFetchedDate | changeTimeZone: preferences.timeZone: dateFormat) })
                                : 'Mention.details.engagement.nodateTime.tooltip'"
                            [escape]="false"
                            tooltipPosition="right"
                        ></span>
                    }
                </ng-template>

                @if (mention?.engagements) {
                    <div class="agpr-mentionDetails-engagement-metadataWrapper">
                        @for (attribute of engagementInformation; track attribute.label) {
                            @if (attribute.type === attributeTypesEnum.percent) {
                                <agpr-meta-data
                                    class="agpr-mentionDetails-engagement-metadata"
                                    [type]="attribute.type"
                                    [icon]="attribute.icon"
                                    [value]="(attribute.value || attribute.value === 0)
                                        ? (attribute.value | number: '1.0-2')
                                        : null"
                                    [tooltip]="attribute.label"
                                    [ariaLabel]="attribute.label"
                                ></agpr-meta-data>
                            } @else {
                                <agpr-meta-data
                                    class="agpr-mentionDetails-engagement-metadata"
                                    [type]="attribute.type"
                                    [icon]="attribute.icon"
                                    [value]="(attribute.value || attribute.value === 0)
                                        ? (attribute.value | number)
                                        : null"
                                    [tooltip]="attribute.label"
                                    [ariaLabel]="attribute.label"
                                ></agpr-meta-data>
                            }
                        }
                    </div>
                } @else {
                    <agpr-message
                        [severity]="messageSeverityEnum.noContent"
                        [useWhiteBg]="true"
                    >
                        <span
                            [ngClass]="{
                                'agpr-mentionDetails-noContentRetweet': (mention?.tweetData?.type === tweetTypeEnum.RETWEET)
                            }"
                        >
                            {{
                                (mention?.tweetData?.type === tweetTypeEnum.RETWEET) ?
                                ('Mention.details.engagement.notAvailable' | localize) :
                                ('Mention.details.engagement.noContent' | localize)
                            }}
                        </span>
                    </agpr-message>
                }
            </agpr-panel>
        }

        <agpr-panel
            *ngIf="!!mention.mentionId"
            class="agpr-mentionDetails"
            header="Mention.details.prominence"
            [clickExcludeIds]="['mentionDetails_mentionProminenceLink']"
        >
            <ng-template #panelHeader>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-infoIconStyle"
                    agprTooltip="Mention.details.prominence.tooltip"
                    tooltipPosition="left"
                    [escape]="false"
                ></span>
                <div class="agpr-panelHeader-actionButtons">
                    <a
                        id="mentionDetails_mentionProminenceLink"
                        class="fa-regular fa-duotone fa-gear"
                        agprTooltip="Mention.details.prominenceSettings"
                        tooltipPosition="left"
                        (click)="openProminenceTakeOverPanel()"
                    ></a>
                </div>
            </ng-template>
            <ng-container *ngIf="hasProminenceProvision">
                <agpr-message
                    *ngIf="!!prominenceStatus && prominenceStatus !== prominenceStatuses.DONE"
                    [severity]="prominenceStatus === prominenceStatuses.FAILED ? messageSeverityEnum.error : messageSeverityEnum.warning"
                >
                    <ng-container *ngIf="prominenceStatus === prominenceStatuses.ONGOING || prominenceStatus === prominenceStatuses.PENDING">
                        {{'AccountPreferences.prominence.disclaimer.cannotEdit' | localize}}
                    </ng-container>
                    <ng-container *ngIf="prominenceStatus === prominenceStatuses.FAILED">
                        {{'AccountPreferences.prominence.disclaimer.contactEngineering' | localize}}
                    </ng-container>
                </agpr-message>
                <agpr-message
                    *ngIf="!prominenceStatus || (prominenceStatus === prominenceStatuses.DONE && (mentionProminence?.length < 1 || mention.prominenceScores?.length < 1))"
                    [useWhiteBg]="true"
                    [bottomMargin]="false"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{'Mention.details.noProminenceInfo' | localize}}
                </agpr-message>
                <ng-container *ngIf="prominenceStatus === prominenceStatuses.DONE && mentionProminence?.length > 0">
                    <agpr-attribute-list [attributes]="mentionProminence"></agpr-attribute-list>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!hasProminenceProvision">
                <agpr-message
                    [severity]="messageSeverityEnum.info"
                    [bottomMargin]="false"
                >
                    <div [innerHTML]="'AccountPreferences.prominence.disclaimer.noProminence' | localize: { contactLink: noProminenceContactLink }"></div>
                </agpr-message>
            </ng-container>
        </agpr-panel>
        @if (!isDetailsTakeOverPanel) {
            <agpr-panel
                header="Mention.details.mention"
            >
                <a
                    *ngIf="mention.isLexisNexis"
                    href="http://www.lexisnexis.com"
                    target="_blank"
                >
                    <img
                        src="/app/assets/images/lexisNexisFullLogo.png"
                        [alt]="'MediaType.lexisNexis' | localize"
                        class="agpr-mentionDetails-brandedLogo"
                    />
                </a>
                <img
                    *ngIf="mention.isBurrelles"
                    src="/app/assets/images/burrellesIconUpdate.png"
                    [alt]="'MediaType.burrelles.logo' | localize"
                    class="agpr-mentionDetails-brandedLogo"
                    agprTooltip="MediaType.burrelles"
                    tooltipPosition="left"
                />
                <article
                    [id]="id + '.article'"
                    class="agpr-mention"
                >
                    @if (!mention.isFinancialTimes) {
                        <div
                            *ngIf="openAiPermission"
                            class="agpr-mentionDetails-translate"
                        >
                            <agpr-mention-translation-tabs
                                [selectedTabIndex]="selectedTabIndex"
                                [mention]="mention"
                                (tabChanged)="tabChanged($event)"
                                [tabsHeadingLevel]="5"
                            >
                            </agpr-mention-translation-tabs>
                        </div>
                        <agpr-mention-set-preferred
                            [id]="id"
                            [openAiPermission]="openAiPermission"
                            [selectedTabIndex]="selectedTabIndex"
                            [mention]="mention"
                            [autoSave]="true"
                            (tabChanged)="tabChanged($event)"
                        >
                        </agpr-mention-set-preferred>
                    }

                    <div
                        [ngClass]="{'agpr-mentionDetails-body-container': openAiPermission && !mention.isFinancialTimes}"
                    >

                    <div class="agpr-mentionDetails-headline">
                        <span *ngIf="mention.headline && selectedTabIndex === tabIds.ORIGINAL" [innerHTML]="mention.headline | highlightKeywords:highlightKeywords"></span>
                        <span *ngIf="mention.headline && selectedTabIndex === tabIds.TRANSLATED" [innerHTML]="mention?.translation?.headline | indexHighlight:mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup"></span>
                        <span *ngIf="!mention.headline">{{ mention.mediaType.noHeadlineMessage | localize }}</span>
                    </div>
                    <div class="agpr-mentionDetails-metadata">
                        <div class="agpr-mentionDetails-metadataItem">
                            <ng-container *ngIf="mention.publication.name">
                                <ng-container *ngIf="isLegacyTargetingUser">
                                    <a
                                        class="agpr-mentionDetails-link"
                                        [id]="id + '.publicationLink'"
                                        *ngIf="(
                                            (mention.publication.outletUrl && !isLegacyTargetingUser)
                                            || (mention.publication.agilityOutletURL && isLegacyTargetingUser)
                                        ); else pubNameLegacy"
                                        [href]="mention.publication.outletUrl"
                                        target="_blank"
                                    >
                                        <ng-container *ngTemplateOutlet="pubNameLegacy"></ng-container>
                                    </a>
                                    <ng-template #pubNameLegacy>
                                        <span>{{ mention.publication?.name }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="!isLegacyTargetingUser">
                                    <agpr-button
                                        *ngIf="mention.publication?.uuid; else pubName"
                                        [id]="id + '.publicationLink'"
                                        class="agpr-mentionDetails-link"
                                        [style]="buttonTypes.link"
                                        (click)="outletClicked.emit()"
                                    >
                                        <ng-container *ngTemplateOutlet="pubName"></ng-container>
                                    </agpr-button>
                                    <ng-template #pubName>
                                        <span>{{ mention.publication?.name }}</span>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="agpr-mentionDetails-metadataItem">
                            <ng-container *ngIf="mention.author.name">
                                <span>{{ mention.linkedinData?.type === linkedinTypeEnum.REPOST ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                                <span>{{ mention.isRetweet ? ('Mention.RetweetedBy' | localize) : "" }}</span>
                                <span>{{ mention.isTweetReply ? ('Mention.TweetReply' | localize) : "" }}</span>
                                <ng-container *ngIf="isLegacyTargetingUser">
                                    <a
                                        class="agpr-mentionDetails-link"
                                        [id]="id + '.authorLink'"
                                        *ngIf="mention.author.contactUrl; else authorNameLegacy"
                                        [href]="mention.author.contactUrl"
                                        target="_blank"
                                    >
                                        <ng-container *ngTemplateOutlet="authorNameLegacy"></ng-container>
                                    </a>
                                    <ng-template #authorNameLegacy>
                                        <span>{{ mention.author?.name }}</span>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="!isLegacyTargetingUser">
                                    <agpr-button
                                        *ngIf="mention.author?.uuid; else authorName"
                                        [id]="id + '.authorLink'"
                                        class="agpr-mentionDetails-link"
                                        [style]="buttonTypes.link"
                                        (click)="contactClicked.emit()"
                                    >
                                        <ng-container *ngTemplateOutlet="authorName"></ng-container>
                                    </agpr-button>
                                    <ng-template #authorName>
                                        <span>{{ mention.author?.name }}</span>
                                    </ng-template>
                                </ng-container>
                            </ng-container>
                        </div>
                        <div class="agpr-mentionDetails-metadataItem">
                            <span class="agpr-mentionDetails-metadataLabel">
                                {{ 'Mention.datePublished' | localize }}
                            </span>
                            <ng-container *ngIf="preferences">
                                {{ mention.datePublished | changeTimeZone: preferences.timeZone: dateFormat }}
                            </ng-container>
                        </div>
                        <div
                            *ngIf="mention.dateAvailable"
                            class="agpr-mentionDetails-metadataItem"
                        >
                            <span class="agpr-mentionDetails-metadataLabel">
                                {{ 'Mention.dateAvailable' | localize }}
                            </span>
                            <ng-container *ngIf="preferences">
                                {{ mention.dateAvailable | changeTimeZone: preferences.timeZone: dateFormat }}
                            </ng-container>
                        </div>
                    </div>
                    <section class="agpr-mentionDetails-body">
                        <ng-container *ngIf="selectedTabIndex === tabIds.ORIGINAL">
                            <p
                            class="agpr-mentionDetails-paragraph"
                            *ngFor="let paragraph of bodyParagraphs"
                            [innerHTML]="
                                    paragraph
                                    | mentionLinks : mention.mediaType.id
                                    | indexHighlightSup
                                    "
                            >
                            </p>
                            <agpr-original-tweet
                                [tweetData]="mention.tweetData"
                            ></agpr-original-tweet>
                        </ng-container>
                        <ng-container *ngIf="selectedTabIndex === tabIds.TRANSLATED">
                            <p
                                class="agpr-mentionDetails-paragraph"
                                *ngFor="let paragraph of mention?.translation?.paragraphs"
                                [innerHTML]="
                                    paragraph
                                        | mentionLinks : mention.mediaType.id
                                        | indexHighlightSup
                                "
                            >
                            </p>
                            <agpr-original-tweet
                                [tweetData]="mention.tweetData"
                            ></agpr-original-tweet>
                        </ng-container>
                    </section>
                    <section
                        *ngIf="mention.cachedUrl"
                    >
                        <agpr-button
                            (click)="window.open(mention.cachedUrl, '_blank')"
                            [label]="'Mention.details.viewPdfButtonLabel'"
                            [style]="buttonTypes.tertiary"
                        ></agpr-button>
                    </section>
                    <ng-container *ngIf="selectedTabIndex === tabIds.ORIGINAL">
                        @if (mention.summary && !mention.isFinancialTimes) {
                            <section
                                class="agpr-mentionDetails-summaryHeading"
                            >
                                {{ ('Mention.details.contextualSnippet' | localize) }}
                            </section>
                            <section class="agpr-mentionDetails-summaryBody">
                                <p
                                    class="agpr-mentionDetails-paragraph"
                                    *ngFor="let paragraph of summaryParagraphs"
                                    [innerHTML]="
                                        paragraph
                                            | mentionLinks : mention.mediaType.id
                                            | highlightKeywords: highlightKeywords
                                    "
                                >
                                </p>
                            </section>
                        } @else if (mention.isFinancialTimes) {
                            <agpr-financial-times-attribution
                                [mention]="mention"
                            ></agpr-financial-times-attribution>
                        }
                    </ng-container>
                    <ng-container *ngIf="selectedTabIndex === tabIds.TRANSLATED">
                        <ng-container
                            *ngIf="mention.translation?.summary && mention.translation?.summaryParagraphs"
                        >
                            <section
                                class="agpr-mentionDetails-summaryHeading"
                            >
                                {{ ('Mention.details.contextualSnippet' | localize) }}
                            </section>
                            <section class="agpr-mentionDetails-summaryBody">
                                <p
                                    class="agpr-mentionDetails-paragraph"
                                    *ngFor="let paragraph of mention.translation?.summaryParagraphs"
                                    [innerHTML]="
                                        paragraph
                                            | mentionLinks : mention.mediaType.id
                                            | indexHighlight:mention?.translation?.headlineHighlightIndexes : highlightKeywords | indexHighlightSup
                                    "
                                >
                                </p>
                            </section>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="attachments.length">
                        <td class="agpr-mentionDetails-summaryHeading">
                            {{ ('Mention.details.attachments' | localize) }}
                        </td>
                        <section>
                            <ng-container *ngFor="let attachment of attachments">
                                <agpr-button
                                    class="agpr-mentionDetails-attachment"
                                    [style]="buttonTypes.link"
                                    (click)="downloadAttachment(attachment)"
                                >
                                    {{ attachment.name }}
                                </agpr-button>
                            </ng-container>
                        </section>
                    </ng-container>
                </div>
                @if (showImageList) {
                    <div class="agpr-mentionDetails-imageList">
                        <agpr-image-list
                            [images]="mention.images"
                            [showPopover]="true"
                            [showPreferredImageButton]="true"
                            (preferredImageChanged)="updatePreferredImage($event)"
                        ></agpr-image-list>
                    </div>
                }
                <div
                    *ngIf="(mention.isPmgXcago || mention.viewerUrlType === viewerUrlTypeEnum.PDF) && mention.viewerUrl"
                    class="agpr-mentionDetails-viewPdf"
                >
                    <a
                        class="agpr-mentionDetails-viewPdf-link"
                        [id]="id + '_pmgXcagoViewPdf'"
                        [href]="mention.viewerUrl + '?mode=PDF'"
                        target="_blank"

                        >
                            {{ 'Mention.details.pmgXcago.viewMentionPdf' | localize }}
                        </a>
                        <i class="fa-regular fa-arrow-up-right-from-square"></i>
                    </div>

                </article>

                <div
                    class="agpr-mentionDetails-brandedFooterBar"
                    *ngIf="mention.isLexisNexis"
                >
                    <a
                        class="agpr-mentionDetails-brandedFooterBarLink"
                        [id]="id + '.brandedFooterLinkGeneral'"
                        href="http://www.lexisnexis.com/terms/general/"
                        target="_blank"
                    >
                        {{ 'Mention.details.lexisNexis.termsAndConditions' | localize }}
                    </a>
                    <span class="agpr-mentionDetails-brandedFooterBarLink-separator">|</span>
                    <a
                        class="agpr-mentionDetails-brandedFooterBarLink"
                        [id]="id + '.brandedFooterLinkPrivacy'"
                        href="http://www.lexisnexis.com/terms/privacy/"
                        target="_blank"
                    >
                        {{ 'Mention.details.lexisNexis.privacyPolicy' | localize }}
                    </a>
                    <span class="agpr-mentionDetails-brandedFooterBarLink-separator">|</span>
                    <a
                        class="agpr-mentionDetails-brandedFooterBarLink"
                        [id]="id + 'brandedFooterLinkCopyright'"
                        href="http://www.lexisnexis.com/terms/copyright.aspx"
                        target="_blank"
                    >
                        {{ 'Mention.details.lexisNexis.copyright' | localize: { year: currentYear } }}
                    </a>
                </div>
            </agpr-panel>
        }
        <agpr-panel
            header="Mention.workbench.insights"
            *ngIf="showInsights && !isResellerAccount"
            headerIcon="fa-kit-duotone fa-agpr-insights"
        >
            <div class="agpr-mentionDetails-createNewInsight">
                <agpr-button
                    [id]="id + '_createNewInsight'"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-duotone fa-square-plus'"
                    tooltipPosition="top"
                    tooltip="Mention.insights.newInsight"
                    (click)="createNewInsight()"
                >
                </agpr-button>
            </div>
            <div *ngIf="insights?.length">
                <agpr-mention-insight-card
                    *ngFor="let insight of insights"
                    [insight]="insight"
                    (insightEdited)="updateInsight(insight)"
                    (insightDeleted)="deleteInsight(insight)"
                    (insightPreferred)="preferInsight(insight)"
                >
                </agpr-mention-insight-card>
            </div>

            <agpr-message
                *ngIf="!insights?.length"
                [severity]="messageSeverityEnum.noContent"
                [useWhiteBg]="true"
            >
                <span>
                    {{ 'Mention.workbench.insights.noContent' | localize }}
                </span>
            </agpr-message>
        </agpr-panel>
        <!--
            The clip view needs to be shown/hidden instead of conditionally re-rendered
            so that the iframe element is already rendered when the src is added.
            Otherwise, the load event on the iframe could fire before Angular registers it.
        -->
        <agpr-panel
            *ngIf="isCriticalMention && isCriticalMentionValid && criticalMentionSlimPlayerURL"
            header="Mention.details.mentionView"
        >
            <div
                class="agpr-mentionDetails-mentionNotShareable"
            >
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Mention.details.criticalMentionUnavailable' | localize }}
                </agpr-message>
            </div>
        </agpr-panel>
        <agpr-message
            *ngIf="isCriticalMention && !isCriticalMentionValid"
            [severity]="messageSeverityEnum.info"
        >
            {{ criticalMentionFeedbackMessage | localize }}
        </agpr-message>

        <div
            *ngIf="socialEmbedURL || socialEmbedCode"
            class="agpr-mentionDetails-socialView"
        >
            <agpr-panel
                header="Mention.details.mentionView"
            >
                <div
                    class="agpr-mentionDetails-socialContainer"
                    [ngClass]="'agpr-mentionDetails-socialContainer--' + mention.mediaType.id"
                    [agprLoading]="!isSocialFrameLoaded"

                >
                    <iframe
                        *ngIf="socialEmbedURL"
                        class="agpr-mentionDetails-socialFrame"
                        [ngClass]="'agpr-mentionDetails-socialFrame--' + mention.mediaType.id"
                        [src]="socialEmbedURL | agprBypassURLSecurity"
                        (load)="isSocialFrameLoaded = true"
                        [title]="iframeTitle"
                    ></iframe>
                    <iframe
                        *ngIf="socialEmbedCode"
                        class="agpr-mentionDetails-socialFrame"
                        [ngClass]="'agpr-mentionDetails-socialFrame--' + mention.mediaType.id"
                        [srcdoc]="socialEmbedCode"
                        (load)="isSocialFrameLoaded = true"
                        [title]="iframeTitle"
                    ></iframe>
                </div>
            </agpr-panel>
        </div>

        <agpr-mention-view-tveyes-panel
            [mention]="mention"
            [mentionSearch]="search"
            [highlightKeywords]="highlightKeywords"
        ></agpr-mention-view-tveyes-panel>

        <agpr-panel
            class="agpr-mentionInformation"
            header="Mention.details.mentionSharing"
        >
            <agpr-content-sharing
                [id]="id + '.selectedMention'"
                *ngIf="mention.shareable"
                [content]="mention.sharingInformation"
                class="agpr-mentionDetails-contentSharing"
            ></agpr-content-sharing>
            <div
                *ngIf="!mention.shareable"
                class="agpr-mentionDetails-mentionNotShareable"
            >
                {{ 'Mention.details.mentionNotShareable' | localize }}
            </div>
        </agpr-panel>
        <agpr-panel
            *ngIf="mentionAttributes?.length > 0"
            class="agpr-mentionDetails"
            header="Mention.details.mentionDetails"
        >
            <agpr-attribute-list
                [attributes]="mentionAttributes"
            >
            </agpr-attribute-list>
        </agpr-panel>
    }
</ng-container>

<ng-template let-subject #prominenceAttributeTemplate>
    <span class="agpr-prominence">
        {{subject.label}}
        <span class="agpr-prominence-label">
            {{subject.customLabel}}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-prominence-icon"
                [agprTooltip]="subject.iconToolTip.split(',') | chipTooltip : 'Mention.details.prominence.keywords'"
                tooltipPosition="top"
                [escape]="false"
            ></span>
        </span>
    </span>
</ng-template>

